import {
  css, type Interpolation,
} from '@emotion/react';

export const dataTableWrapperStyle = css({
  height: '100%',
  minHeight: 0,
});

/**
 * Use this when pagination or other meta element is present. The meta element already provides enough padding.
 */
export const overridePaddingStyle = {
  paddingBottom: 3,
} as const satisfies Interpolation;

export const tabDataTableWrapperStyle = {
  padding: 16,
} as const satisfies Interpolation;

export const splitScreenDataTableWrapperStyle = {
  padding: 8,
  flex: '1 1 100%',
  display: 'flex',
  flexDirection: 'column',
} as const satisfies Interpolation;
